export default {
  salesTrackingGeneral: (state) => {
    return state.salesTrackingGeneral;
  },

  // Supplier Stats
  suppliersStats: (state) => {
    return state.suppliersStats;
  },
  supplierCombinedStats: (state) => {
    return state.supplierCombinedStats;
  },
  supplierMonthStats: (state) => {
    return state.supplierMonthStats;
  },
  specificSupplierStats: (state) => {
    return state.specificSupplierStats;
  },
  supplierSalesEnquiryBuyerTypeStats: (state) => {
    return state.supplierSalesEnquiryBuyerTypeStats;
  },
  supplierLeadsBuyerTypeStats: (state) => {
    return state.supplierLeadsBuyerTypeStats;
  },
  supplierGoodCauseCCStats: (state) => {
    return state.supplierGoodCauseCCStats;
  },

  // Good Cause Stats
  specificGoodCauseStats: (state) => {
    return state.specificGoodCauseStats;
  },
  goodCauseSupplierCategoryCCStats: (state) => {
    return state.goodCauseSupplierCategoryCCStats;
  },
  goodCauseSalesEnquiryBuyerTypeStats: (state) => {
    return state.goodCauseSalesEnquiryBuyerTypeStats;
  },
  goodCauseLeadsBuyerTypeStats: (state) => {
    return state.goodCauseLeadsBuyerTypeStats;
  },

  // Impact Buyer Stats
  specificBuyerStats: (state) => {
    return state.specificBuyerStats;
  },
  impactBuyerChosenGoodCause: (state) => {
    return state.impactBuyerChosenGoodCause;
  },
};
